export default function generateCacheName(s) {
  return s.replace(/[-:/]+[^-:/]/gm, (x) => x[x.length - 1].toUpperCase());
}
